import { memo } from 'react';
import { css } from '@emotion/react';
import { Handle, Position } from '@xyflow/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { SharedNodeProps } from '../data';
import { draggableStyles } from './styles';

export const TreeOptionNode = memo(({ data }: SharedNodeProps) => {
  const handles = {
    top: { id: 'top' },
    bottom: { id: 'bottom' },
  };
  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        id={handles.top.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
      <div
        css={[
          css`
            width: 24px;
            height: 24px;
            background-color: ${theme.colors.neutral90};
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
          `,
          draggableStyles,
        ]}
      >
        <Text as='span' color='white' weight='bold' size='small'>
          {data.label}
        </Text>
      </div>
      <Handle
        type='source'
        position={Position.Bottom}
        id={handles.bottom.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
    </>
  );
});
TreeOptionNode.displayName = 'TreeOptionNode';
